import React, { useState, useEffect } from "react";
// import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";

import Logo from "../../assets/png/logo.png";

import { db } from "../../utils/firebase/firebase";
import useAnalysesOnSnapshot from "../../hooks/useAnalysesOnSnapshot";
// import ImageGraph from "../../components/graphs/ImageGraph";
import OneSampleTTestResult from "../../components/analysis/results/OneSampleTTestResult";
import TwoSampleTTestResult from "../../components/analysis/results/TwoSampleTTestResult";
import ANOVAOneWayResult from "../../components/analysis/results/ANOVAOneWayResult";
import CorrelationResult from "../../components/analysis/results/CorrelationResult";
import DescriptiveStatsResult from "../../components/analysis/results/DescriptiveStatsResult";
import GraphicalSummaryResult from "../../components/analysis/results/GraphicalSummaryResult";
import NormalityTestResult from "../../components/analysis/results/NormalityTestResult";
import PairedTTestResult from "../../components/analysis/results/PairedTTestResult";
import ImageGraph from "../../components/graphs/ImageGraph";
import ResponseListResult from "../../components/analysis/results/ResponseListResult";

const FileAnalysis = () => {
  const { documentId } = useParams();
  const [fileName, setFileName] = useState("");
  const { analyses } = useAnalysesOnSnapshot(documentId);

  useEffect(() => {
    const docRef = doc(db, "Documents", documentId);

    const getDocumentData = async () => {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists) {
        setFileName(docSnap.data().details.fileName);
      }
    };

    getDocumentData();
  }, [documentId]);

  // useEffect(() => {
  //   console.log("analyses", analyses);
  // }, [analyses]);

  // useEffect(() => {
  //   console.log("allTests", allTests);
  // }, [allTests]);

  const handleGridRowSpan = (test) => {
    let span = 1;
    /**
     * TODO: define how much tests take up certain spaces.
     * use Descriptive Statistics as a base. and multiply their span.
     *
     *
     * note: if span is still 1, DO NOT return 1 || 1 / span 1;
     *
     * 1s = Simple Boxplot, Simple Histogram, Correlation
     * 6s = Pareto Chart,
     */
    // console.log("test.title", test.title);
    if (test.title === "1-Sample t") {
      test.graphs.boxplot && span++;
      test.graphs.histogram && span++;
      // span = test.graphs.boxplot ? span + 1 : span;
      // span = test.graphs.histogram ? span + 1 : span;
    }

    if (test.title === "2-Sample t") {
      span++;
      test.graphs.isBoxplot && span++;
      test.graphs.isHistogram && span++;
    }

    if (test.title === "Graphical Summary") {
      span = span + 2;
      // span = test.boxplot ? span + 1 : span;
      // span = test.histogram ? span + 1 : span;
    }

    // if (test.title === "Pareto Chart") {
    //   span++;
    // }

    if (test.title === "Paired t") {
      span++;
      test.graphs.isBoxplot && span++;
      test.graphs.isHistogram && span++;
      test.graphs.isIVP && span++;
    }

    let output = span === 1 ? null : `1 / span ${span}`;
    // console.log("output :>> ", output);

    return output;
  };

  const handleMainDisplay = (test) => {
    if (test?.responseList) {
      return <ResponseListResult test={test} />;
    } else {
      if (test.title === "ANOVA (One-way)") {
        // return <h6>{test.title}</h6>;
        return <ANOVAOneWayResult oneway={test} />;
      }
      if (test.title === "Correlation") {
        // return <h6>{test.title}</h6>;
        return <CorrelationResult cor={test} />;
      }
      if (test.title === "Descriptive Statistics") {
        // return <h6>{test.title}</h6>;
        return <DescriptiveStatsResult stats={test} />;
      }
      if (test.title === "Graphical Summary") {
        // return <h6>{test.title}</h6>;
        return <GraphicalSummaryResult summary={test} />;
      }
      if (test.title === "Normality Test") {
        // return <h6>{test.title}</h6>;
        return <NormalityTestResult norm={test} />;
      }
      if (test.title === "Paired t") {
        // return <h6>{test.title}</h6>;
        return <PairedTTestResult paired={test} />;
      }
      if (
        test.title === "Multi Variable Boxplot (Group)" ||
        test.title === "Multi Variable Histogram"
      ) {
        return (
          <ImageGraph
            url={
              test.title === "Multi Variable Boxplot (Group)"
                ? test.groupBoxplot
                : test.groupHistogram
            }
            title={test.title}
            column={test.column}
            percent={"GraphOnly"}
            dateTime={test.dateTime}
            analysisId={test.id}
          />
        );
      }

      if (test.title === "2-Sample t") {
        return <TwoSampleTTestResult result={test} />;
      }

      if (test.title === "1-Sample t") {
        return <OneSampleTTestResult test={test} />;
      }

      if (
        test.title === "Time Series" ||
        test.title === "Simple Boxplot" ||
        test.title === "Simple Histogram" ||
        test.title === "Simple Scatterplot" ||
        test.title === "Pareto Chart"
      ) {
        return (
          <ImageGraph
            url={
              test.title === "Simple Boxplot"
                ? test.boxplot
                : test.title === "Simple Histogram"
                ? test.histogram
                : test.title === "Time Series"
                ? test.timeseries
                : test.title === "Simple Scatterplot"
                ? test.scatterplot
                : test.percentage
            }
            title={test.title}
            column={test.column}
            percent={"GraphOnly"}
            dateTime={test.dateTime}
            x={test.x}
            y={test.y}
            firstColumn={test.firstColumn}
            secondColumn={test.secondColumn}
            // percetageURL={test.percentage || false}
            analysisId={test.id}
            pearson={test.pearsonr}
          />
        );
      }
    }
  };

  return (
    <Box sx={{ padding: "2rem", minHeight: "100vh", background: "#f5f5f5" }}>
      {/* Header */}
      <Box mb={2} sx={{ display: "flex" }}>
        {/* Logo */}
        <Box mr={2}>
          <Link to="/">
            <img src={Logo} alt="alpha tuos" width={100} />
          </Link>
        </Box>

        {/* Title */}
        <Box>
          <h1>{fileName}</h1>
          <h2>Analysis</h2>
        </Box>
      </Box>

      {/* Main */}
      <Box component={"main"}>
        <Box
          sx={{
            display: "grid",
            // gridAutoFlow: "row dense",
            // gridAutoRows: "auto",
            gap: "1rem",
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)",
              md: "repeat(2, 1fr)",
              xl: "repeat(3, 1fr)",
            },
          }}
        >
          {analyses.map((test) => {
            return (
              <Box
                sx={{
                  background: "white",
                  // gridColumn: "1",
                  // gridRow: handleGridRowSpan(test),
                  // gridColumn: "1",
                  borderRadius: "7px",
                }}
                key={test.id}
              >
                <Container
                  style={{
                    // backgroundColor: "white",
                    // borderRadius: "7px",
                    padding: "20px",
                    marginBottom: "20px",
                  }}
                >
                  {handleMainDisplay(test)}
                </Container>
              </Box>
            );
          })}
          <Box></Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FileAnalysis;
